// APP管理-用户管理
const user = (resolve) => {
  import('components/app/app.user').then((module) => {
    resolve(module)
  })
}
// APP管理-app升级
const upgrade = (resolve) => {
  import('components/app/app.upgrade').then((module) => {
    resolve(module)
  })
}
// APP管理-监管部门
const supervision = (resolve) => {
  import('components/app/app.supervision').then((module) => {
    resolve(module)
  })
}

// 二级账号-监管部门
const supervision2 = (resolve) => {
  import('components/app/app.supervision2').then((module) => {
    resolve(module)
  })
}
// 二级账号-角色管理
const roleManage = (resolve) => {
  import('components/app/app.roleManage').then((module) => {
    resolve(module)
  })
}

const appRouter = {
  appPath: [
    {
      path: '/app/user', // APP管理-用户管理
      component: user,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/app/upgrade', // APP管理-app升级
      component: upgrade,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/app/supervision', // APP管理-监管部门
      component: supervision,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/app/supervision2', // 二级账号-监管部门
      component: supervision2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/app/roleManage', // 二级账号-角色管理
      component: roleManage,
      meta: {
        keepAlive: true
      }
    }
  ]
}

export default appRouter



// WEBPACK FOOTER //
// ./src/router/app.js